import { SEED_QUERY } from './queries/seedQuery.js';
import { getPossibleTemplates, getTemplate } from './getTemplate.js';
import { addApolloState, getApolloClient } from './client.js';
import { getConfig } from './config/index.js';
import { hooks } from './wpHooks/index.js';
import { infoLog, debugLog } from './utils/log.js';
export const DEFAULT_ISR_REVALIDATE = 60 * 15; // 15 minutes
function isSSR(ctx) {
    return ctx.req !== undefined;
}
export async function getWordPressProps(options) {
    var _a, _b, _c;
    const { templates } = getConfig();
    if (!templates) {
        throw new Error('Templates are required. Please add them to your config.');
    }
    const { ctx, props, revalidate } = options;
    const client = getApolloClient();
    let resolvedUrl = null;
    if (!isSSR(ctx)) {
        const wordPressNodeParams = (_a = ctx.params) === null || _a === void 0 ? void 0 : _a.wordpressNode;
        if (wordPressNodeParams && Array.isArray(wordPressNodeParams)) {
            resolvedUrl = `/${wordPressNodeParams.join('/')}`;
        }
        else {
            resolvedUrl = '/';
        }
    }
    else {
        resolvedUrl = ctx.req.url;
        ctx.res.setHeader('x-using', 'faust');
    }
    if (!resolvedUrl) {
        return {
            notFound: true,
        };
    }
    const seedQuery = hooks.applyFilters('seedQueryDocumentNode', SEED_QUERY, {
        resolvedUrl,
    });
    const seedQueryRes = await client.query({
        query: seedQuery,
        variables: { uri: resolvedUrl },
    });
    const seedNode = (_b = seedQueryRes === null || seedQueryRes === void 0 ? void 0 : seedQueryRes.data) === null || _b === void 0 ? void 0 : _b.node;
    debugLog(`Seed Node for resolved url: "${resolvedUrl}": `, seedNode);
    if (!seedNode) {
        return {
            notFound: true,
        };
    }
    infoLog(`Possible templates for resolved url: "${resolvedUrl}":`, getPossibleTemplates(seedNode));
    const template = getTemplate(seedNode, templates);
    if (!template) {
        return {
            notFound: true,
        };
    }
    let templateQueryRes;
    const templateVariables = (template === null || template === void 0 ? void 0 : template.variables)
        ? template === null || template === void 0 ? void 0 : template.variables(seedNode, { asPreview: false, locale: ctx.locale })
        : undefined;
    if (template.query) {
        templateQueryRes = await client.query({
            query: template.query,
            variables: templateVariables,
        });
    }
    const appProps = addApolloState(client, {
        props: Object.assign({ 
            /**
             * The following props may be null coalesced as an "undefined"
             * value is not able to be serialized
             */
            __SEED_NODE__: seedNode !== null && seedNode !== void 0 ? seedNode : null, __TEMPLATE_QUERY_DATA__: (_c = templateQueryRes === null || templateQueryRes === void 0 ? void 0 : templateQueryRes.data) !== null && _c !== void 0 ? _c : null, __TEMPLATE_VARIABLES__: templateVariables !== null && templateVariables !== void 0 ? templateVariables : null }, props),
    });
    if (!isSSR(ctx)) {
        appProps.revalidate = revalidate !== null && revalidate !== void 0 ? revalidate : DEFAULT_ISR_REVALIDATE;
    }
    return appProps;
}
